import { render } from "./PostTitle.vue?vue&type=template&id=d870357a&scoped=true"
import script from "./PostTitle.vue?vue&type=script&lang=js"
export * from "./PostTitle.vue?vue&type=script&lang=js"

import "./PostTitle.vue?vue&type=style&index=0&id=d870357a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d870357a"]])

export default __exports__